export default __webpack_public_path__ + "static/media/RedCasas.ebfa5d47.jpeg";